module.exports = __webpack_public_path__ + "media/94.2e65a861.wav";